import {useContext, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {Divider, Flex, Modal, Steps} from 'antd'
import {CheckCircleOutlined, ExclamationCircleOutlined, ReloadOutlined,} from '@ant-design/icons'
import {NavContext} from '../../context/global_context'
import Button from '../common/Button'
import SelectMakeModel from './SelectMakeModel'
import SelectVersionModal from './SelectVersionModal'

const StartTracerPreviewModal = ({ branch = '', onClose = () => {} }) => {
  const intl = useIntl()
  const [, navDispatch] = useContext(NavContext)

  const [step, setStep] = useState('make_model')
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [versionStatus, setVersionStatus] = useState({
    hasError: false,
    hasVersions: false,
  })
  const versionRef = useRef(null)

  const handleSelectVehicle = (vehicle) => {
    setSelectedVehicle(vehicle)
  }

  const handleNext = () => {
    if (selectedVehicle) {
      setStep('version')
    }
  }

  const handleBack = () => {
    if (step === 'version') {
      setStep('make_model')
      setSelectedVehicle(null)
    } else {
      onClose()
    }
  }

  const stepIndex = step === 'make_model' ? 0 : 1

  const steps = [
    {
      title: intl.formatMessage({ id: 'tracerPreview.stepMakeModel' }),
      icon: stepIndex > 0 ? <CheckCircleOutlined /> : undefined,
    },
    {
      title: intl.formatMessage({ id: 'tracerPreview.stepVersion' }),
    },
  ]

  return (
    <Modal
      title={intl.formatMessage({ id: 'tracerPreview.startTracerPreview' })}
      open
      centered
      maskClosable={false}
      onCancel={onClose}
      destroyOnHidden
      width={640}
      footer={
        <Flex justify="space-between">
          <div>
            <Button onClick={step === 'make_model' ? onClose : handleBack}>
              {step === 'make_model'
                ? intl.formatMessage({ id: 'forms.cancel' })
                : intl.formatMessage({ id: 'tracerPreview.back' })}
            </Button>
          </div>
          {step === 'make_model' && (
            <Button
              type="primary"
              disabled={!selectedVehicle}
              onClick={handleNext}
            >
              {intl.formatMessage({ id: 'forms.next' })}
            </Button>
          )}
          {step === 'version' && versionStatus.hasError && (
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={() => versionRef.current?.retry()}
            >
              {intl.formatMessage({ id: 'tracerPreview.retry' })}
            </Button>
          )}
          {step === 'version' && !versionStatus.hasError && versionStatus.hasVersions && (
            <Button
              type="primary"
              icon={<ExclamationCircleOutlined />}
              onClick={() => versionRef.current?.initiatePreview()}
            >
              {intl.formatMessage({ id: 'tracerPreview.initiatePreview' })}
            </Button>
          )}
        </Flex>
      }
    >
      <Steps
        current={stepIndex}
        size="small"
        items={steps}
        style={{ marginBottom: 24 }}
      />

      <Divider style={{ margin: '0 0 24px' }} />

      {step === 'make_model' ? (
        <SelectMakeModel
          selected={selectedVehicle}
          onSelect={handleSelectVehicle}
          branch={branch}
        />
      ) : (
        <SelectVersionModal
          ref={versionRef}
          vehicle={selectedVehicle?.vehicle_id}
          vehicleName={selectedVehicle?.name}
          branch={branch}
          onBack={handleBack}
          onStatusChange={setVersionStatus}
        />
      )}
    </Modal>
  )
}

export default StartTracerPreviewModal
